import * as React from "react"
import { batch } from "@preact/signals-react";
import { Box } from "@mui/material";
import { SelectSeeker } from "@ui-seeker/core";
import {isEmpty} from "@ui-seeker/utils";

import {DateRangeBlock} from "@components";
import { DATE_PERIODS } from "@constants";
import {rangeDatesShareOfSearchKPI} from "./Ranges";
import {
    shareOfSearchKpiEvolutionCurrentPeriod,
    shareOfSearchKpiEvolutionFilters, shareOfSearchKpiEvolutionKeywordsOptions
} from "../@signals";


export default function ShareOfSearchKPIEvolutionChartToolbar({keywordID, dateRange, onChange}) {

    return <Box sx={{ display: 'flex', gap: 2, alignItems: 'center'}}>

        <DateRangeBlock
            currentPeriodLabel={shareOfSearchKpiEvolutionCurrentPeriod.value}
            maxDays={30}
            value={dateRange}
            ranges={rangeDatesShareOfSearchKPI}
            onChange={onChange}
            onOk = { () => shareOfSearchKpiEvolutionCurrentPeriod.value = DATE_PERIODS.CUSTOM }
        />

        {!isEmpty(shareOfSearchKpiEvolutionKeywordsOptions.value) && <SelectSeeker
            options={shareOfSearchKpiEvolutionKeywordsOptions.value}
            value={keywordID.value}
            onChange = { e => { batch(() => {
                keywordID.value = e.target.value
                shareOfSearchKpiEvolutionFilters.value = {
                    ...shareOfSearchKpiEvolutionFilters.value,
                    ['keyword']: [keywordID.value]
                }
            })}}
        />}
    </Box>
}


